// models
import {
  ContractParametrizationStatus,
  ContractReview,
  ContractReviewApplyResult,
  ContractReviewFinding,
  FindingDecision,
  FindingDecisionItem,
  NewContractReview
} from '../../models/Entities/Contracts/ContractReview';
import { ErrorType } from '../../models/HttpError';

// Revisión de contratos con IA (spec 012)

// Crear
export const CONTRACT_REVIEW_CREATE_REQUEST = 'CONTRACT_REVIEW_CREATE_REQUEST';
export const CONTRACT_REVIEW_CREATE_SUCCESS = 'CONTRACT_REVIEW_CREATE_SUCCESS';
export const CONTRACT_REVIEW_CREATE_FAILURE = 'CONTRACT_REVIEW_CREATE_FAILURE';

export interface ContractReviewCreateRequestAction {
  type: typeof CONTRACT_REVIEW_CREATE_REQUEST;
  contractId: number;
  command: NewContractReview;
}

export interface ContractReviewCreateSuccessAction {
  type: typeof CONTRACT_REVIEW_CREATE_SUCCESS;
  contractId: number;
  review: ContractReview | undefined;
}

export interface ContractReviewCreateFailureAction {
  type: typeof CONTRACT_REVIEW_CREATE_FAILURE;
  contractId: number;
  error: ErrorType;
}

// Listar por contrato
export const CONTRACT_REVIEW_GETALL_REQUEST = 'CONTRACT_REVIEW_GETALL_REQUEST';
export const CONTRACT_REVIEW_GETALL_SUCCESS = 'CONTRACT_REVIEW_GETALL_SUCCESS';
export const CONTRACT_REVIEW_GETALL_FAILURE = 'CONTRACT_REVIEW_GETALL_FAILURE';

export interface ContractReviewGetAllRequestAction {
  type: typeof CONTRACT_REVIEW_GETALL_REQUEST;
  contractId: number;
}

export interface ContractReviewGetAllSuccessAction {
  type: typeof CONTRACT_REVIEW_GETALL_SUCCESS;
  contractId: number;
  reviews: ContractReview[];
}

export interface ContractReviewGetAllFailureAction {
  type: typeof CONTRACT_REVIEW_GETALL_FAILURE;
  contractId: number;
  error: ErrorType;
}

// Detalle
export const CONTRACT_REVIEW_GETBYID_REQUEST = 'CONTRACT_REVIEW_GETBYID_REQUEST';
export const CONTRACT_REVIEW_GETBYID_SUCCESS = 'CONTRACT_REVIEW_GETBYID_SUCCESS';
export const CONTRACT_REVIEW_GETBYID_FAILURE = 'CONTRACT_REVIEW_GETBYID_FAILURE';

export interface ContractReviewGetByIdRequestAction {
  type: typeof CONTRACT_REVIEW_GETBYID_REQUEST;
  reviewId: string;
}

export interface ContractReviewGetByIdSuccessAction {
  type: typeof CONTRACT_REVIEW_GETBYID_SUCCESS;
  reviewId: string;
  review: ContractReview;
}

export interface ContractReviewGetByIdFailureAction {
  type: typeof CONTRACT_REVIEW_GETBYID_FAILURE;
  reviewId: string;
  error: ErrorType;
}

// Decisión individual (optimista: el REQUEST aplica la decisión y guarda la anterior para revertir)
export const CONTRACT_REVIEW_DECISION_REQUEST = 'CONTRACT_REVIEW_DECISION_REQUEST';
export const CONTRACT_REVIEW_DECISION_SUCCESS = 'CONTRACT_REVIEW_DECISION_SUCCESS';
export const CONTRACT_REVIEW_DECISION_FAILURE = 'CONTRACT_REVIEW_DECISION_FAILURE';

export interface ContractReviewDecisionRequestAction {
  type: typeof CONTRACT_REVIEW_DECISION_REQUEST;
  reviewId: string;
  findingId: number;
  decision: FindingDecision;
  comment: string | null;
  previousDecision: FindingDecision;
  previousComment: string | null;
}

export interface ContractReviewDecisionSuccessAction {
  type: typeof CONTRACT_REVIEW_DECISION_SUCCESS;
  reviewId: string;
  findingId: number;
  finding: ContractReviewFinding | undefined;
}

export interface ContractReviewDecisionFailureAction {
  type: typeof CONTRACT_REVIEW_DECISION_FAILURE;
  reviewId: string;
  findingId: number;
  previousDecision: FindingDecision;
  previousComment: string | null;
  error: ErrorType;
}

// Decisión en bloque (DEC-004: todo o nada por lote)
export const CONTRACT_REVIEW_DECISION_BULK_REQUEST = 'CONTRACT_REVIEW_DECISION_BULK_REQUEST';
export const CONTRACT_REVIEW_DECISION_BULK_SUCCESS = 'CONTRACT_REVIEW_DECISION_BULK_SUCCESS';
export const CONTRACT_REVIEW_DECISION_BULK_FAILURE = 'CONTRACT_REVIEW_DECISION_BULK_FAILURE';

export interface ContractReviewDecisionBulkRequestAction {
  type: typeof CONTRACT_REVIEW_DECISION_BULK_REQUEST;
  reviewId: string;
  items: FindingDecisionItem[];
}

export interface ContractReviewDecisionBulkSuccessAction {
  type: typeof CONTRACT_REVIEW_DECISION_BULK_SUCCESS;
  reviewId: string;
  findings: ContractReviewFinding[];
}

export interface ContractReviewDecisionBulkFailureAction {
  type: typeof CONTRACT_REVIEW_DECISION_BULK_FAILURE;
  reviewId: string;
  error: ErrorType;
}

// Aplicar
export const CONTRACT_REVIEW_APPLY_REQUEST = 'CONTRACT_REVIEW_APPLY_REQUEST';
export const CONTRACT_REVIEW_APPLY_SUCCESS = 'CONTRACT_REVIEW_APPLY_SUCCESS';
export const CONTRACT_REVIEW_APPLY_FAILURE = 'CONTRACT_REVIEW_APPLY_FAILURE';

export interface ContractReviewApplyRequestAction {
  type: typeof CONTRACT_REVIEW_APPLY_REQUEST;
  reviewId: string;
}

export interface ContractReviewApplySuccessAction {
  type: typeof CONTRACT_REVIEW_APPLY_SUCCESS;
  reviewId: string;
  result: ContractReviewApplyResult | undefined;
}

export interface ContractReviewApplyFailureAction {
  type: typeof CONTRACT_REVIEW_APPLY_FAILURE;
  reviewId: string;
  error: ErrorType;
}

// Estado de parametrización (D-6, DEC-003)
export const CONTRACT_REVIEW_PARAMETRIZATION_REQUEST = 'CONTRACT_REVIEW_PARAMETRIZATION_REQUEST';
export const CONTRACT_REVIEW_PARAMETRIZATION_SUCCESS = 'CONTRACT_REVIEW_PARAMETRIZATION_SUCCESS';
export const CONTRACT_REVIEW_PARAMETRIZATION_FAILURE = 'CONTRACT_REVIEW_PARAMETRIZATION_FAILURE';

export interface ContractReviewParametrizationRequestAction {
  type: typeof CONTRACT_REVIEW_PARAMETRIZATION_REQUEST;
  contractId: number;
}

export interface ContractReviewParametrizationSuccessAction {
  type: typeof CONTRACT_REVIEW_PARAMETRIZATION_SUCCESS;
  contractId: number;
  status: ContractParametrizationStatus;
}

export interface ContractReviewParametrizationFailureAction {
  type: typeof CONTRACT_REVIEW_PARAMETRIZATION_FAILURE;
  contractId: number;
  error: ErrorType;
}

// Deshacer un hallazgo aplicado (spec 015; Contracts 021 §4.1)
export const CONTRACT_REVIEW_UNDO_FINDING_REQUEST = 'CONTRACT_REVIEW_UNDO_FINDING_REQUEST';
export const CONTRACT_REVIEW_UNDO_FINDING_SUCCESS = 'CONTRACT_REVIEW_UNDO_FINDING_SUCCESS';
export const CONTRACT_REVIEW_UNDO_FINDING_FAILURE = 'CONTRACT_REVIEW_UNDO_FINDING_FAILURE';

export interface ContractReviewUndoFindingRequestAction {
  type: typeof CONTRACT_REVIEW_UNDO_FINDING_REQUEST;
  reviewId: string;
  findingId: number;
}

export interface ContractReviewUndoFindingSuccessAction {
  type: typeof CONTRACT_REVIEW_UNDO_FINDING_SUCCESS;
  reviewId: string;
  findingId: number;
  finding: ContractReviewFinding | undefined;
}

export interface ContractReviewUndoFindingFailureAction {
  type: typeof CONTRACT_REVIEW_UNDO_FINDING_FAILURE;
  reviewId: string;
  findingId: number;
  error: ErrorType;
}

// Deshacer la revisión completa (spec 015; Contracts 021 §4.2)
export const CONTRACT_REVIEW_UNDO_REQUEST = 'CONTRACT_REVIEW_UNDO_REQUEST';
export const CONTRACT_REVIEW_UNDO_SUCCESS = 'CONTRACT_REVIEW_UNDO_SUCCESS';
export const CONTRACT_REVIEW_UNDO_FAILURE = 'CONTRACT_REVIEW_UNDO_FAILURE';

export interface ContractReviewUndoRequestAction {
  type: typeof CONTRACT_REVIEW_UNDO_REQUEST;
  reviewId: string;
}

export interface ContractReviewUndoSuccessAction {
  type: typeof CONTRACT_REVIEW_UNDO_SUCCESS;
  reviewId: string;
  result: ContractReviewApplyResult | undefined;
}

export interface ContractReviewUndoFailureAction {
  type: typeof CONTRACT_REVIEW_UNDO_FAILURE;
  reviewId: string;
  error: ErrorType;
}

// Limpiezas
export const CONTRACT_REVIEW_CLEAR_UNDO_RESULT = 'CONTRACT_REVIEW_CLEAR_UNDO_RESULT';

export interface ContractReviewClearUndoResultAction {
  type: typeof CONTRACT_REVIEW_CLEAR_UNDO_RESULT;
}

export const CONTRACT_REVIEW_CLEAR_CREATE_STATUS = 'CONTRACT_REVIEW_CLEAR_CREATE_STATUS';
export const CONTRACT_REVIEW_CLEAR_APPLY_RESULT = 'CONTRACT_REVIEW_CLEAR_APPLY_RESULT';

export interface ContractReviewClearCreateStatusAction {
  type: typeof CONTRACT_REVIEW_CLEAR_CREATE_STATUS;
}

export interface ContractReviewClearApplyResultAction {
  type: typeof CONTRACT_REVIEW_CLEAR_APPLY_RESULT;
}

export type ContractReviewKnownAction =
  | ContractReviewCreateRequestAction
  | ContractReviewCreateSuccessAction
  | ContractReviewCreateFailureAction
  | ContractReviewGetAllRequestAction
  | ContractReviewGetAllSuccessAction
  | ContractReviewGetAllFailureAction
  | ContractReviewGetByIdRequestAction
  | ContractReviewGetByIdSuccessAction
  | ContractReviewGetByIdFailureAction
  | ContractReviewDecisionRequestAction
  | ContractReviewDecisionSuccessAction
  | ContractReviewDecisionFailureAction
  | ContractReviewDecisionBulkRequestAction
  | ContractReviewDecisionBulkSuccessAction
  | ContractReviewDecisionBulkFailureAction
  | ContractReviewApplyRequestAction
  | ContractReviewApplySuccessAction
  | ContractReviewApplyFailureAction
  | ContractReviewParametrizationRequestAction
  | ContractReviewParametrizationSuccessAction
  | ContractReviewParametrizationFailureAction
  | ContractReviewUndoFindingRequestAction
  | ContractReviewUndoFindingSuccessAction
  | ContractReviewUndoFindingFailureAction
  | ContractReviewUndoRequestAction
  | ContractReviewUndoSuccessAction
  | ContractReviewUndoFailureAction
  | ContractReviewClearUndoResultAction
  | ContractReviewClearCreateStatusAction
  | ContractReviewClearApplyResultAction;
